import script from "./SubColumnSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./SubColumnSetting.vue?vue&type=script&setup=true&lang=js"

import "./SubColumnSetting.vue?vue&type=style&index=0&id=cbe61fb0&lang=scss&scoped=true"

import exportComponent from "/root/workspace/public_sso_ZgiA/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cbe61fb0"]])

export default __exports__